import { Formik } from 'formik'

import { useEffect, useState } from 'react'

import { Box, Flex } from '@grupoboticario/flora-react'

import PageTitle from '@/components/PageTitle/PageTitle'
import Shipping from '@/components/RegisterData/components/Shipping'
import UserInfos from '@/components/RegisterData/components/UserInfos'
import ContactsTable from '@/components/Table/ContactsTable/ContactsTable'
import { userSchema } from '@/utils/validators/userSchema'

import * as S from './UserForm.styles'

const UserForm = ({
  onValidMemberInformationChange,
  defaultMember = {},
  defaultAddress = {
    postalCode: '',
    streetAddress: '',
    addressNumber: '',
    district: '',
    complement: '',
    addressLocality: '',
    addressRegion: '',
    country: ''
  },
  defaultPhones = [],
  defaultEmails = []
}) => {
  const [member, setMember] = useState(defaultMember)
  const [address, setAddress] = useState(defaultAddress)
  const [errors, setErrors] = useState({})
  const [phones, setPhones] = useState(defaultPhones)
  const [emails, setEmails] = useState(defaultEmails)

  const onAddPhone = (phone) => setPhones([...phones, phone])
  const onRemovePhone = (phone) => setPhones(phones.filter((existingPhone) => existingPhone.value !== phone.value))
  const onAddEmail = (email) => setEmails([...emails, email])
  const onRemoveEmail = (email) => setEmails(emails.filter((existingEmails) => existingEmails.value !== email.value))
  const isFormWithErrors = (errors) => Object.keys(errors).some((key) => typeof errors[key] === 'string')
  const getMemberObject = (formState) => ({
    birthDate: formState.birthDate || '',
    email: formState.email || '',
    familyName: formState.familyName || '',
    gender: formState.gender || '',
    givenName: formState.givenName || '',
    nationality: formState.nationality || '',
    whatsapp: formState.whatsapp || ''
  })
  const getAddressObject = (address, member) => ({
    streetAddress: address.streetAddress,
    addressNumber: member.addressNumber || '',
    district: address.district,
    complement: member.complement || '',
    postalCode: address.postalCode,
    addressLocality: address.addressLocality,
    addressRegion: address.addressRegion,
    localityCode: address.localityCode,
    addressType: address.addressType,
    geolocation: address.geolocation
  })
  const getMemberInformation = () => ({
    ...getMemberObject(member),
    address: getAddressObject(address, member),
    whatsapp: phones[0]?.value || '',
    email: emails[0]?.value || ''
  })

  const [initialValues, setInitialValues] = useState({
    complement: member?.complement || '',
    addressNumber: member?.addressNumber || '',
    whatsapp: phones[0]?.value || '',
    email: emails[0]?.value || '',
    ...address,
    ...getMemberObject(member)
  })

  useEffect(() => {
    if (address?.postalCode)
      setInitialValues({ ...getMemberInformation(), ...address, complement: '', addressNumber: '' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address])

  useEffect(() => {
    setInitialValues({
      ...getMemberInformation(),
      whatsapp: phones[0]?.value || '',
      email: emails[0]?.value || ''
    })

    if (member.email && !isFormWithErrors(errors))
      onValidMemberInformationChange(getMemberInformation(), phones, emails)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [member, phones, emails, errors])

  return (
    <Formik enableReinitialize initialValues={initialValues} onSubmit={() => {}} validationSchema={userSchema}>
      {({ errors, values, handleChange }) => {
        setMember(values)
        setErrors(errors)

        return (
          <Flex direction="column" gap="$6">
            <Box css={S.fieldGroupCss}>
              <UserInfos errors={errors} handleChange={handleChange} newMember={true} />
            </Box>
            <Box css={S.fieldGroupCss}>
              <PageTitle>Endereço</PageTitle>
              <Shipping address={address} errors={errors} setAddress={setAddress} />
            </Box>
            <Box css={S.fieldGroupCss}>
              <PageTitle>Telefone</PageTitle>
              <ContactsTable
                contactType="TELEPHONE"
                data={phones}
                handleUpdate={(phone, event) => (event === 'ADD' ? onAddPhone(phone) : onRemovePhone(phone))}
                isLocal
              />
            </Box>
            <Box css={S.fieldGroupCss}>
              <PageTitle>E-mail</PageTitle>
              <ContactsTable
                contactType="EMAIL"
                data={emails}
                handleUpdate={(email, event) => (event === 'ADD' ? onAddEmail(email) : onRemoveEmail(email))}
                isLocal
              />
            </Box>
          </Flex>
        )
      }}
    </Formik>
  )
}

export default UserForm
